import { StudentProfileInfo } from '@interfaces/Student'
export const STORE_INSTRUCTOR_STUDENT_PROFILE = 'studentData/STORE_INSTRUCTOR_STUDENT_PROFILE'

export const setStudentData = (id: string, profile: StudentProfileInfo) => ({
  type: STORE_INSTRUCTOR_STUDENT_PROFILE,
  id,
  profile,
})
